// lib/guide-cta-sell.ts
// Soft vs hard sell for the guide mid-article CTA (Priority 304). Tone only:
// "hard" is the filled button, "soft" is the same label as a text link. The
// link contract (outbound hop vs internal next/link) is still decided by
// `variant` in components/public/MidArticleCta.tsx — sell never changes
// where a CTA goes or how it is tracked.
//
// Pure, no guide data imported here, so the client component can use it
// without pulling lib/guides.ts into the bundle.

export type GuideCtaSell = "soft" | "hard";

export type GuideCtaVariant = "hop" | "playbook" | "hub";

/** An affiliate hop is the hard sell; internal hub/playbook navigation is soft. */
export function defaultGuideCtaSell(variant: GuideCtaVariant): GuideCtaSell {
  return variant === "hop" ? "hard" : "soft";
}

/** A guide's explicit `sell` wins; otherwise the variant default applies. */
export function resolveGuideCtaSell(variant: GuideCtaVariant, sell?: GuideCtaSell): GuideCtaSell {
  return sell ?? defaultGuideCtaSell(variant);
}
